export default __webpack_public_path__ + "static/media/attack-experiment.c8d00ce0fa618d12e28146b1280de52c.svg";